module.exports = __webpack_public_path__ + "static/img/welcome-new.0315f83b.png";